var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.shouldShowRegeneratePromptBlock
      ? _c("div", { staticClass: "ia-prompt-regenerate mb-3" }, [
          _c("div", { staticClass: "ia-prompt-regenerate__body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "ia-prompt-regenerate__content" }, [
              _c("div", { staticClass: "ia-prompt-regenerate__title" }, [
                _vm._v(
                  "\n          This Images report was generated with a different prompt\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ia-prompt-regenerate__text" }, [
                _vm._v("\n          Current report prompt:\n          "),
                _c("strong", [_vm._v(_vm._s(_vm.currentReportPromptLabel))]),
                _vm._v(".\n          Selected prompt:\n          "),
                _c("strong", [_vm._v(_vm._s(_vm.selectedPromptLabel))]),
                _vm._v(".\n        "),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-sm ia-prompt-regenerate__btn",
              attrs: { type: "button", disabled: _vm.isRegenerating },
              on: {
                click: function ($event) {
                  return _vm.$emit("regenerate")
                },
              },
            },
            [
              _c("i", {
                staticClass: "bi",
                class: _vm.isRegenerating
                  ? "bi-hourglass-split"
                  : "bi-arrow-clockwise",
              }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.isRegenerating
                      ? "Regenerating..."
                      : "Re-generate with selected prompt"
                  ) +
                  "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "ia-card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "ia-stats" }, [
        _c("div", { staticClass: "ia-stat" }, [
          _c("div", { staticClass: "ia-stat__label" }, [
            _vm._v("\n          Average Score\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ia-score" }, [
            _c(
              "div",
              { staticClass: "ia-score__value", class: _vm.scoreColorClass },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.averageScore) + "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ia-score__suffix" }, [
              _vm._v("\n            /100\n          "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ia-progress",
              attrs: {
                role: "progressbar",
                "aria-valuenow": _vm.averageScore,
                "aria-valuemin": "0",
                "aria-valuemax": "100",
              },
            },
            [
              _c("div", {
                staticClass: "ia-progress__bar",
                style: { width: `${_vm.clampedScore}%` },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ia-stat" }, [
          _c("div", { staticClass: "ia-stat__label" }, [
            _vm._v("\n          Total Images\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ia-stat__big" }, [
            _vm._v("\n          " + _vm._s(_vm.images.length) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ia-stat__sub" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ia-stat" }, [
          _c("div", { staticClass: "ia-stat__label" }, [
            _vm._v("\n          Issues Found\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ia-stat__big ia-stat__big--warn" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.imageIssuesFound) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ia-stat__sub" }, [
            _vm._v("\n          images need attention\n        "),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "pi-card mt-4" }, [
      _c(
        "div",
        { staticClass: "pi-head" },
        [
          _c("h2", { staticClass: "pi-head__title" }, [
            _vm._v("\n        Product Images\n      "),
          ]),
          _vm._v(" "),
          !_vm.readOnly ? _c("ImageSequenceDropdown") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "image-sequence-table-wrap",
        domProps: { innerHTML: _vm._s(_vm.preparedImageContent) },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ia-prompt-regenerate__icon" }, [
      _c("i", { staticClass: "bi bi-arrow-clockwise" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ia-card__header" }, [
      _c("i", {
        staticClass: "bi bi-image ia-card__icon",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ia-card__title" }, [
        _vm._v("\n        Image Analysis Overview\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }